// Phát hiện bản deploy mới: so mã build đang chạy với `/version.json` trên server.
// `version.json` do plugin trong vite.config.ts sinh ra lúc build; dev server không
// có file này nên luôn coi như "không có bản mới".

const CURRENT_BUILD_ID: string | undefined = import.meta.env.APP_BUILD_ID;

/** true khi server đang phục vụ một bản build khác bản đang chạy trong tab này. */
export async function hasNewAppVersion(): Promise<boolean> {
  if (!CURRENT_BUILD_ID || typeof window === "undefined") return false;
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
    if (!res.ok) return false;
    const data = (await res.json()) as { buildId?: unknown };
    return typeof data.buildId === "string" && data.buildId !== CURRENT_BUILD_ID;
  } catch {
    // Mất mạng / đang deploy dở: lần kiểm tra sau sẽ thử lại.
    return false;
  }
}
